import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";

/**
 * Hook to fetch festival editions that a specific user has attended.
 * Used on profile festival pages to only show editions the user interacted with.
 */
export function useUserAttendedEditions(
	festivalId: string | null,
	userId: string | null,
) {
	return trpc.festival.getUserAttendedEditions.useQuery(
		{ festivalId: festivalId!, userId: userId! },
		{
			enabled: !!festivalId && !!userId,
			...CACHE_TIERS.DYNAMIC,
		},
	);
}
